import { LOYALTY_STATUS } from '../actions/Loyalty';

type LoyaltyStateType = {
  showClaimPopup: boolean,
  showLogin: boolean,
  showLastChanceToRegister: boolean,
  lastChanceRegisterConfirmed: boolean,
  showRegistration: boolean,
  showRecoverPassword: boolean,
  loggedUser: Object,
  maxPercentUsage: number,
  coinsForRegistering: number,
  maxCoinsToApply: number,
  coinsEntered: number,
  newMember: boolean,
  coinsApplied: number,
  discountApplied: number,
  memberInfo: Object,
  selectedStatus: string,
  conversionRates: Object,
  checkoutCoins: number,
};

const initialState = {
  showClaimPopup: true,
  showLogin: false,
  showLastChanceToRegister: false,
  lastChanceRegisterConfirmed: false,
  showRegistration: false,
  showRecoverPassword: false,
  // Store the user details when is logged
  loggedUser: null,
  // If user has registered in the current session
  hasRegistered: false,
  // Max percent can be applied if you're a loyalty member.
  maxPercentUsage: 25,
  // Coins you'll obtain if you registered as a new loyalty member
  coinsForRegistering: 0,
  // Max coins to apply from total available
  maxCoinsToApply: 0,
  // Entered coins by user
  coinsEntered: 0,
  // Coins applied on your booking
  coinsApplied: 0,
  newMember: false,
  discountApplied: 0,
  memberInfo: null,
  selectedStatus: LOYALTY_STATUS.DONT_WANT_MEMBER,
  // Conversion rates to convert coins to currency equivalent
  conversionRates: [],
  checkoutCoins: 0,
};

// eslint-disable-next-line default-param-last
export const loyalty = (state: LoyaltyStateType = initialState, action) => {
  switch (action.type) {
    case 'LOYALTY_SET_SHOW_CLAIM_POPUP':
      return { ...state, showClaimPopup: action.show };
    case 'LOYALTY_SET_SHOW_LOGIN':
      return { ...state, showLogin: action.show };
    case 'LOYALTY_SET_SHOW_LAST_CHANCE_TO_REGISTER':
      return { ...state, showLastChanceToRegister: action.show };
    case 'LOYALTY_SET_LAST_CHANCE_TO_REGISTER_CONFIRMED':
      return { ...state, lastChanceRegisterConfirmed: action.show };
    case 'LOYALTY_SET_LOGGED_USER':
      return { ...state, loggedUser: action.user };
    case 'LOYALTY_SET_MAX_PERCENT_USAGE':
      return { ...state, maxPercentUsage: action.percent };
    case 'LOYALTY_SET_HAS_REGISTERED':
      return { ...state, hasRegistered: action.hasRegistered };
    case 'LOYALTY_SET_COINS_FOR_REGISTERING':
      return { ...state, coinsForRegistering: action.coins };
    case 'LOYALTY_SET_MAX_COINS_TO_APPLY':
      return { ...state, maxCoinsToApply: action.coins };
    case 'LOYALTY_SET_COINS_ENTERED':
      return { ...state, coinsEntered: action.coins };
    case 'LOYALTY_SET_NEW_MEMBER':
      return { ...state, newMember: action.newMember };
    case 'LOYALTY_SET_NEW_MEMBER_DISCOUNT_PERCENTAGE':
      return { ...state, newMemberDiscountPercentage: action.newMemberDiscountPercentage };
    case 'LOYALTY_SET_CURRENT_STAYS':
      return { ...state, currentStays: action.currentStays };
    case 'LOYALTY_SET_CURRENT_NIGHTS':
      return { ...state, currentNights: action.currentNights };
    case 'LOYALTY_SET_OPTIN_ACCEPTED':
      return { ...state, optinAccepted: action.optinAccepted };
    case 'LOYALTY_SET_SA_NET_RATE_PERCENTAGE':
      return { ...state, saNetRatepercentage: action.saNetRatepercentage };
    case 'LOYALTY_SET_NIGHTS_NEEDED_TO_UPGRADE':
      return { ...state, nightsNeededToUpgrade: action.nightsNeededToUpgrade };
    case 'LOYALTY_SET_PROGRAM_TYPE':
      return { ...state, programType: action.programType };
    case 'LOYALTY_SET_IS_AGENCY_ADMIN':
      return { ...state, isAgencyAdmin: action.isAgencyAdmin };
    case 'LOYALTY_SET_NEXT_LOYALTY_LEVEL':
      return { ...state, nextLoyaltyLevel: action.nextLoyaltyLevel };
    case 'LOYALTY_SET_AGENCY_SCHEMA':
      return { ...state, agencySchema: action.agencySchema };
    case 'LOYALTY_SET_CHECKOUT_COINS':
      return { ...state, checkoutCoins: action.checkoutCoins };
    case 'LOYALTY_SET_COINS_APPLIED':
      return { ...state, coinsApplied: action.coins };
    case 'LOYALTY_SET_DISCOUNT_APPLIED':
      return { ...state, discountApplied: action.discount };
    case 'LOYALTY_SET_SHOW_REGISTRATION':
      return { ...state, showRegistration: action.show };
    case 'LOYALTY_SET_MEMBER_INFO':
      return { ...state, memberInfo: action.memberInfo };
    case 'LOYALTY_SET_SELECTED_STATUS':
      return { ...state, selectedStatus: action.selectedStatus };
    case 'LOYALTY_SET_SHOW_RECOVER_PASSWORD':
      return { ...state, showRecoverPassword: action.show };
    case 'LOYALTY_SET_CONVERSION_RATES':
      return { ...state, conversionRates: action.conversionRates };
    default:
      return state;
  }
};
